<template>
  <div>
    <!-- <div class="crumbs"> -->
    <!-- <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 系统消息
        </el-breadcrumb-item>
      </el-breadcrumb> -->
    <!-- </div> -->
    <div style="margin-bottom: 10px">
      <el-button icon="el-icon-arrow-left" @click="handleGoBack()"
        >返回</el-button
      >
    </div>
    <div class="container">
      <el-tabs
        :stretch="true"
        v-model="activeName"
        type="card"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="item in tabpanLabel"
          :key="item.name"
          :name="item.name"
        >
          <span slot="label">
            <el-badge
              :value="item.count"
              :hidden="item.count == 0 ? true : false"
              :max="99"
              class="item"
              >{{ item.label }}</el-badge
            >
          </span>
        </el-tab-pane>
      </el-tabs>
      <div class="tablelist-box">
        <div class="select-btn">
          <span>只看未读</span>
          <el-switch v-model="switchValue" @change="handleSwitch"> </el-switch>
        </div>
        <TableList
          class="tablelist"
          :loading="loading"
          :index-show="true"
          :table-data="tableData"
          :table-label="tableLabel"
          :row-key="rowKey"
        >
          <template v-slot:status="slot">
            <el-link
              @click="handleRead(slot.scope.row, slot.scope.$index)"
              :underline="false"
              :type="slot.scope.row.status == 1 ? 'danger' : ''"
              >{{ slot.scope.row.status == 1 ? "未读" : "已读" }}</el-link
            >
          </template>
        </TableList>
      </div>
      <div class="pagination">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="productTagPage.pageNum"
          :page-size="productTagPage.pageSize"
          :total="productTagPage.pageTotal"
          :small="true"
        >
        </el-pagination>
      </div>
    </div>
    <div>
      <el-button icon="el-icon-arrow-left" @click="handleGoBack()"
        >返回</el-button
      >
    </div>
  </div>
</template>

<script>
import TableList from '../../components/common/e-table-list'
import api from '../../api/user'
export default {
  components: {
    TableList,
  },
  props: {},
  data () {
    return {
      loading: false,
      tableData: [],
      tableLabel: [
        { label: '消息内容', param: 'content', align: 'center' },
        { label: '状态', param: 'status', width: '100', align: 'center', slot: "status" },
        { label: '日期', param: 'createTime', width: '200', align: 'center' },
      ],
      productTagPage: {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      rowKey: 'roleId',
      activeName: 'product',
      tabpanLabel: [
        {
          label: '订单管理',
          name: 'order',
          count: 0,
          Identity: 'double_identity'
        },
        {
          label: '商品审核',
          name: 'product',
          count: 0,
          Identity: 'supplier',
        },
        {
          label: '协议管理',
          name: 'agreement',
          count: 0,
          Identity: 'purchase'
        },
        {
          label: '品牌销售商城',
          name: 'shop',
          count: 0,
          Identity: 'double_identity'
        },
        // {
        //   label: '专属采购区',
        //   name: 'order',
        //   count: 0,
        //   Identity: 'double_identity'
        // },
        // {
        //   label: '询比价',
        //   name: 'priceQuery',
        // count:0,
        // },
        // {
        //   label: '系统消息',
        //   name: 'system',
        //   count: 0,
        //   Identity: ''
        // },
      ],
      supplierLabel: [
        {
          label: '订单管理',
          name: 'supplierOrder',
          count: 0,
          Identity: 'double_identity'
        },
         {
          label: '协议管理',
          name: 'agreement',
          count: 0,
          Identity: 'purchase'
        },
        {
          label: '商品审核',
          name: 'product',
          count: 0,
          Identity: 'supplier',
        },
        {
          label: '品牌销售商城',
          name: 'shop',
          count: 0,
          Identity: 'double_identity'
        },
        // {
        //   label: '系统消息',
        //   name: 'system',
        //   count: 0,
        //   Identity: ''
        // },
      ],
      purchaseLabel: [
        {
          label: '订单管理',
          name: 'purchaseOrder',
          count: 0,
          Identity: 'double_identity'
        },
        {
          label: '协议管理',
          name: 'agreement',
          count: 0,
          Identity: 'purchase'
        },
        // {
        //   label: '专属采购区',
        //   name: 'order',
        //   count: 0,
        //   Identity: 'double_identity'
        // },
        // {
        //   label: '系统消息',
        //   name: 'system',
        //   count: 0,
        //   Identity: ''
        // },
      ],
      switchValue: false,
      unreadData: [],
      allData: [],

    }
  },
  created () {

    this.queryUnreadCount();
    switch (this.$store.state.USERINFO.memberIdentity) {
      case 'supplier': this.tabpanLabel = this.supplierLabel;
        break;
      case 'purchase': this.tabpanLabel = this.purchaseLabel;
        break;
    }
    if (this.$store.state.USERINFO.memberIdentity == 'double_identity') {
      this.activeName = 'order';
    } else {
      this.activeName = this.$store.state.moduleBelong.moduleBelong;
    }

  },
  mounted () {

    this.queryMallNotice();
  },
  computed: {
    data () {
      return this.$store.state.moduleBelong.moduleBelong
    }
  },
  watch: {
    data (newVal, oldVal) {
      console.log(newVal, oldVal)
      if (this.$store.state.USERINFO.memberIdentity == "double_identity") {
        if (newVal == 'purchaseOrder' || newVal == 'supplierOrder') {
          this.activeName = 'order'
        } else {
          this.activeName = newVal;
        }
      } else {
        this.activeName = newVal;
      }
      this.queryMallNotice();
    },
  },
  methods: {


    // 企业运营中心查询消息
    async queryMallNotice () {
      let params = {
        action: this.activeName,
        pageSize: this.productTagPage.pageSize,
        pageNum: this.productTagPage.pageNum
      }
      await api.queryMallNotice(params).then((res) => {
        if (res.code == "200") {
          this.productTagPage.pageTotal = res.data.total;
          this.unreadData = [];
          this.allData = res.data.records;
          res.data.records.forEach(item => {
            if (item.status == 1) {
              this.unreadData.push(item)
            }
          })
          if (this.switchValue) {
            this.tableData = this.unreadData;
          } else {
            this.tableData = this.allData;
          }
        }
      });
    },

    // 查看消息
    async handleRead (row, index) {
      if (row.status == 1) {
        this.tabpanLabel.forEach(item => {
          if (item.name == this.activeName) {
            item.count--
          }
        })
        await api.readNotice({ noticeId: row.noticeId }).then(res => {
          if (res.code == "200" && res.message == "OK") {
            this.$set(this.tableData, index, { status: 2 });
            this.queryMallNotice();
            this.queryUnreadCount();
          }
        })
      }
    },

    // 获取未读数量
    async queryUnreadCount () {

      await api.queryUnreadCount().then(res => {
        this.tabpanLabel.map(item1 => {
          let str = '';
          if (item1.name == 'purchaseOrder' || item1.name == 'supplierOrder') {
            str = 'order'
          } else {
            str = item1.name
          }
          res.data.map(item2 => {
            if (str == item2.moduleBelong) {
              item1.count = item2.count
            }
          })
        })
      })
    },


    handleSwitch (row) {
      if (row) {
        this.tableData = this.unreadData;
      } else {
        this.tableData = this.allData;
      }
    },


    // 点击 选项卡
    handleClick (tab) {
      this.activeName = tab.name;

      this.queryMallNotice();
    },


    handleSizeChange (val) {
      this.productTagPage.pageSize = val
      this.productTagPage.pageNum = 1
      this.queryMallNotice();
    },
    handleCurrentChange (val) {
      this.productTagPage.pageNum = val
      this.queryMallNotice();
    },

    // 返回上一页
    handleGoBack () {
      this.$store.state.tagsList.map((item, index) => {
        if (item.path == this.$route.path) {
          this.$store.state.tagsList.splice(index, 1);
        }
      })
      this.$router.go(-1)
    },
  }

}
</script>

<style scoped lang="scss">
@import "../../../../assets/css/table";
.container {
  padding: 0;
}
.tablelist-box {
  box-sizing: border-box;
  padding: 0 20px;
}

.select-btn {
  display: flex;
  font-size: 12px;
  color: #666;
  float: right;
  justify-content: space-between;
  align-items: center;
  width: 100px;
  height: 30px;
  margin: 10px 0;
}
.pagination {
  padding-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
  box-sizing: border-box;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-top:2px #2587ff solid !important;
  background: #f4f7ff !important;
  line-height: 38px;
  color: #2587ff !important;
  // border-left: none;
  // border-right: none;
}
::v-deep .el-tabs__header {
  margin: 0;
}
::v-deep .el-tabs__nav-wrap.is-scrollable {
  padding: 0;
}
::v-deep .el-tabs__item {
  border-top: 2px #fff solid ;
  line-height: 38px;
  color: #333333 !important;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}
::v-deep .el-badge__content.is-fixed {
  right: 0;
  top: 14px;
  background: #f0250f;
}
.tablelist {
  width: 100%;
}
</style>
